module.exports = __webpack_public_path__ + "static/media/TN-Women-Knits-2.0.d675a812.svg";